import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ch0005',
    ecrans: ['00-2']
});
